(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const gallery = root.querySelector('.tl-gallery');
    const lightbox = root.querySelector('.tl-lightbox');
    const images = [...root.querySelectorAll('.tl-image-open')];
    const form = root.querySelector('.tl-product-form');
    const quantity = form.querySelector('[name="quantity"]');
    const sticky = root.querySelector('.tl-sticky');
    const cta = root.querySelector('.tl-add');
    const footer = document.querySelector('.tl-footer');
    let zoomIndex = 0;
    let opener;
    let scrollFrame = 0;
    const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

    function showImage(index) {
      if (!images.length) return;
      zoomIndex = (index + images.length) % images.length;
      const source = images[zoomIndex].querySelector('img');
      const target = lightbox.querySelector('img');
      target.src = source.currentSrc || source.src;
      target.alt = source.alt;
    }
    function openImage(index, trigger) {
      opener = trigger;
      showImage(index);
      lightbox.showModal();
    }
    images.forEach((item, index) => item.addEventListener('click', () => openImage(index, item), options));
    root.querySelectorAll('.tl-video-thumb').forEach(button => button.addEventListener('click', () => openImage(0, button), options));
    lightbox.querySelector('.tl-lightbox-close').addEventListener('click', () => lightbox.close(), options);
    lightbox.querySelector('.tl-lightbox-prev').addEventListener('click', () => showImage(zoomIndex - 1), options);
    lightbox.querySelector('.tl-lightbox-next').addEventListener('click', () => showImage(zoomIndex + 1), options);
    lightbox.addEventListener('click', event => {
      if (event.target !== lightbox) return;
      const rect = lightbox.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) lightbox.close();
    }, options);
    lightbox.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        showImage(zoomIndex + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    }, options);
    lightbox.addEventListener('close', () => opener?.focus(), options);

    form.addEventListener('submit', event => {
      if (!window.TimelineCartUI) return;
      event.preventDefault();
      window.TimelineCartUI.add(form, event.submitter || cta);
    }, options);

    const videos = [...root.querySelectorAll('.tl-video-item video')];
    videos.forEach(video => {
      const item = video.closest('.tl-video-item');
      const play = item.querySelector('.tl-video-play');
      const mute = item.querySelector('[data-video-mute]');
      video.muted = true;
      function showVolume() {
        mute.textContent = video.muted ? 'Sound off' : 'Sound on';
        mute.setAttribute('aria-label', video.muted ? 'Unmute product video' : 'Mute product video');
        mute.setAttribute('aria-pressed', String(video.muted));
      }
      play.addEventListener('click', async () => {
        video.controls = true;
        try {
          await video.play();
        } catch {
          play.hidden = false;
          play.setAttribute('aria-label', 'Retry playing product video');
        }
      }, options);
      mute.addEventListener('click', () => {
        video.muted = !video.muted;
        showVolume();
      }, options);
      video.addEventListener('volumechange', showVolume, options);
      video.addEventListener('playing', () => {
        play.hidden = true;
        videos.forEach(other => { if (other !== video) other.pause(); });
      }, options);
      video.addEventListener('pause', () => { play.hidden = false; }, options);
      showVolume();
    });

    const autoplayVideo = root.querySelector('[data-product-autoplay] video');
    let autoplayObserver;
    if (autoplayVideo) {
      autoplayVideo.loop = true;
      autoplayVideo.muted = true;
      autoplayVideo.playsInline = true;
      autoplayVideo.controls = true;
      let inView = false;
      function startVisibleVideo() {
        if (inView && !document.hidden) autoplayVideo.play().catch(() => {});
        else autoplayVideo.pause();
      }
      autoplayObserver = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        startVisibleVideo();
      }, { threshold: .25 });
      autoplayObserver.observe(autoplayVideo);
      document.addEventListener('visibilitychange', startVisibleVideo, options);
    }

    const items = () => [...gallery.children].filter(item => item.offsetWidth > 0);
    const position = root.querySelector('[data-gallery-position]');
    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    function currentSlide() {
      const left = gallery.getBoundingClientRect().left;
      return items().reduce((best, item, index, all) => Math.abs(item.getBoundingClientRect().left - left) < Math.abs(all[best].getBoundingClientRect().left - left) ? index : best, 0);
    }
    function updateGallery() {
      const all = items();
      if (!all.length) return;
      const index = currentSlide();
      position.textContent = `${index + 1} / ${all.length}`;
      previous.disabled = index === 0;
      next.disabled = index === all.length - 1;
    }
    function moveSlide(delta) {
      const all = items();
      const index = Math.max(0, Math.min(all.length - 1, currentSlide() + delta));
      const rect = gallery.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(gallery).paddingLeft) || 0;
      gallery.scrollTo({ left: gallery.scrollLeft + all[index].getBoundingClientRect().left - rect.left - padding, behavior: reducedMotion() ? 'instant' : 'smooth' });
    }
    previous.addEventListener('click', () => moveSlide(-1), options);
    next.addEventListener('click', () => moveSlide(1), options);
    gallery.addEventListener('scroll', updateGallery, { passive: true, signal: controller.signal });

    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' });
    function updatePurchase(changeUrl = false) {
      const input = root.querySelector('.tl-package input:checked');
      if (!input) return;
      quantity.value = String(Math.max(1, Math.min(99, Math.floor(Number(quantity.value) || 1))));
      root.querySelectorAll('.tl-package').forEach(label => label.classList.toggle('is-selected', label.contains(input)));
      root.querySelectorAll('[data-selected-price]').forEach(price => { price.textContent = money.format(Number(input.dataset.priceCents) * Number(quantity.value) / 100); });
      root.querySelector('[data-sticky-selection]').textContent = input.dataset.title + (Number(quantity.value) > 1 ? ` × ${quantity.value}` : '');
      if (changeUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState(null, '', url);
      }
    }
    root.querySelectorAll('.tl-package input').forEach(input => input.addEventListener('change', () => updatePurchase(true), options));
    quantity.addEventListener('change', () => updatePurchase(), options);
    quantity.addEventListener('input', () => { if (quantity.value !== '') updatePurchase(); }, options);
    root.querySelector('[data-quantity-minus]').addEventListener('click', () => { quantity.value = String(Number(quantity.value) - 1); updatePurchase(); }, options);
    root.querySelector('[data-quantity-plus]').addEventListener('click', () => { quantity.value = String(Number(quantity.value) + 1); updatePurchase(); }, options);
    const requested = new URL(location.href).searchParams.get('variant');
    const selected = [...root.querySelectorAll('.tl-package input')].find(input => input.value === requested);
    if (selected) selected.checked = true;
    updatePurchase();

    function updateSticky() {
      const rect = cta.getBoundingClientRect();
      sticky.hidden = rect.bottom >= 0 || (footer && footer.getBoundingClientRect().top < innerHeight - 90);
    }
    function onScroll() {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => { scrollFrame = 0; updateSticky(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true, signal: controller.signal });
    window.addEventListener('resize', () => { updateGallery(); updateSticky(); }, options);
    const resize = new ResizeObserver(() => { updateGallery(); updateSticky(); });
    resize.observe(root);
    updateGallery();
    updateSticky();
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) {
        resize.disconnect();
        autoplayObserver?.disconnect();
        controller.abort();
        cancelAnimationFrame(scrollFrame);
      }
    }, options);
  }
  document.querySelectorAll('[data-timeline-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-timeline-product]').forEach(init));
})();
